import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';


import { ApiService } from 'src/app/Services/api.service';
import { LoaderService } from 'src/app/Services/loader.service';

import { CommonServices } from '../../../../../Services/common.service';
import { ExcelExportService } from '../../../../../Services/excel.service';


@Component({
  selector: 'app-driver-app-usage-reports',
  templateUrl: './driver-app-usage-reports.component.html',
  styleUrls: ['./driver-app-usage-reports.component.css']
})
export class DriverAppUsageReportsComponent implements OnInit {

  public formFilters: any = FormGroup;

  public myDate = new Date();
  public maxDate: any;
  public objectKeys = Object.keys;
  public processedData: any = {};
  public enableAllOption: boolean = true;
  /* Pagination */
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  };
  fieldsData: any = {};
  addObj: any = {};

  constructor(
    public fb: FormBuilder,
    public comService: CommonServices,
    public api: ApiService,
    public loader: LoaderService,
    public excel: ExcelExportService
  ) {
    this.maxDate = new Date(
      this.myDate.getFullYear(),
      this.myDate.getMonth(),
      this.myDate.getDate() - 1
    );
    this.getRegNos();
    this.getVehicleDetails();
  }
  public startDateError: boolean;
  public allVehDownload: boolean;
  public showTable: boolean = false;
  public tableData = [];
  public excelData: any = {};
  public vehicles: any;
  public selectedSingleVeh: any = '';
  public vehicleRegNos: any
  public cols = [
    { key: '#', display: '#' },
    { key: 'date', display: 'Date / Time' },
    {
      key: 'vehRegNo', display: 'Reg no', headerConfig: { isDefault: true },
      subKey: 'compRating',
      config: {
        isComplaint: true,  // give complaint first
        isVehicle: true
      }
    },
    { key: 'driverName', display: 'Driver name', headerConfig: { isDefault: true } },
    { key: 'driverMobile', display: 'Driver mobile number', headerConfig: { isDefault: true } },
    { key: 'duration', display: 'App usage duration', headerConfig: { isDefault: true } },
  ];
  public noDataFoundEnable: boolean = false;
  ngOnInit(): void {
    this.reactiveForm();
    // this.getAllVehicleForDash('')

  }

  reactiveForm() {
    this.formFilters = this.fb.group({
      selectedVehicle: ['', Validators.required],
      sDate: ['', Validators.required],
      eDate: ['', Validators.required],
      speedLimit: [''],
      hours: [0, Validators.required],
      minutes: [5, Validators.required]

    }, {
      validator: [this.comService.formToDateValidation('sDate', 'eDate', 'selectedVehicle')]
    });
  }

  getRegNos() {
    this.api.getOrgVehicleRegNos({}).then((res: any) => {
      if (res.status == 'success') {
        this.vehicleRegNos = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }


  getVehicleDetails() {
    const obj = {
      orgID: localStorage.orgID,//this.orgID == null ? this.storage.get('vendorID_orgID').orgID : this.orgID,
      vendorID: localStorage.vendorID //this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
    };
    this.api.transportManagerVehicleList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.vehicles = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });

  }

  async submitForm(obj) {
    // let obj;
    this.excelData = {};
    this.tableData = [];
    this.showTable = false;
    this.loader.show();
    let selectedVehs = [];
    let payload;
    if (obj['formFilds'] !== undefined) {
      let formFilds = obj.formFilds;
      this.fieldsData = formFilds;
      if (formFilds.selectedVehicle == 'ALL') {
        selectedVehs = this.vehicles
          .filter(veh => veh.vehRegNo)  // Ensure vehRegNo exists
          .map(veh => veh.vehRegNo)     // Extract vehRegNo
          .sort();
        if (selectedVehs.length > 0) { formFilds['selectedVehs'] = selectedVehs }
      } else {
        formFilds['selectedVehs'] = [formFilds.selectedVehicle];
      }
      payload = {
        startDate: new Date(formFilds.sDate).getTime(),
        vehRegNo: formFilds['selectedVehs'],
        minutes: formFilds['minutes'],
        limit: 10,
        page: 1
      }
    } else {
      payload = obj;
    }
    this.addObj = payload;
    this.getAppUsageApiFunc(payload)
  }

  getAppUsageApiFunc(payload) {

    this.api.transportManagerDriverAppUsageData(payload).then((res: any) => {
      this.loader.hide();
      if (res['data'].length > 0 && res['status'] == 'success') {
        this.showTable = true;
        this.tableData = res['data'].map((data) => {
          return {
            ...data,
            date: this.comService.timestampToDate(data?.time, 'DMY H:M:S'),
            duration: this.comService.convertSecondsToMinutes(data?.duration)
          };
        });
        this.processPagination(res, payload);
        this.excelDataGeneration(payload);
      } else {
        this.showTable = false;
      }
    }).catch((err) => {
      console.log(err)
    });
  }
  excelDataGeneration(payload) {
    delete payload['limit'],
      delete payload['page'];
    this.api.getDriverAppUsageExl(payload).then((res: any) => {
      let xlData = res['data'];
      this.excelDataFunction(xlData)
    }).catch((err) => {
      console.log(err)
    });
  }

  excelDataFunction(xlData) {
    this.excelData = {};
    let data = [];
    let serialNo = 1;
    for (let i = 0; i < xlData.length; i++) {
      let item = xlData[i];
      try {
        let res = {
          value: [serialNo++,
          item.date ? this.comService.timestampToDate(item?.time, 'DMY H:M:S') : '---',
          item.vehRegNo ? String(item.vehRegNo).toUpperCase() : '---',
          item.driverName ? this.comService.convertTitleCase(item.driverName) : '---',
          item.driverMobile ? item.driverMobile : '---',
          item.duration ? this.comService.convertSecondsToMinutes(item?.duration) : '---',
          ],
          border: {
            right: { style: 'thin' }, bottom: { style: 'thin' },
          },
        };
        data.push(res);

      } catch (err) {
        console.log(err);
      }
    }
    if (data.length > 0) {
      let rowCount = 2;
      let endCell = 'F';
      let customizedData = [];
      let titleRow = {
        value: ['Mobile App Usage Report'],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },
        },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        alignment: {
          cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: 'FFF' }
        },
      }
      customizedData.push(titleRow);
      rowCount = rowCount + 2;
      let subtitleRow = {
        value: [
          "Start Date       : " + this.comService.timestampToDate(new Date(this.fieldsData.sDate).getTime(), 'DMY') + "\n" +
          "End Date         : " + this.comService.timestampToDate(new Date(this.fieldsData.sDate).getTime(), 'DMY') + ""],
        font: { name: 'Corbel', family: 4, size: 12, },
        border: { right: { style: 'thin' } },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }

      customizedData.push(subtitleRow);

      rowCount = rowCount + 1;
      let headerRow =
      {
        value: ['S No', 'Date / Time', 'Reg no', 'Driver name', 'Driver mobile number', 'App usage duration'],
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
      }
      customizedData.push(headerRow);

      customizedData.push(...data);
      let excelSheetName = 'Mobile App Usage Report'

      if (this.excelData[excelSheetName] == undefined) { this.excelData[excelSheetName] = {}; }

      this.excelData[excelSheetName] = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 18 }, { colNo: 3, width: 18 }, { colNo: 4, width: 25 }, { colNo: 5, width: 20 }, { colNo: 6, width: 30 },],
        }
      }
    }
  }

  async downloadAllVehicleHaltReport() {
    const chunk: any = await this.comService.chunkObject(this.excelData, 50);
    for (let i = 0; i < chunk.length; i++) {
      this.excel.generateExcel(chunk[i], 'Driver_App_Usage_Report_' + i + '_' + this.comService.timestampToDate(new Date(this.fieldsData.sDate).getTime(), 'DMY') + '.xlsx');
    }

  }
  downloadReport() {
    this.excel.generateExcel(this.excelData, 'Driver_App_Usage_Report_' + this.comService.timestampToDate(new Date(this.fieldsData.sDate).getTime(), 'DMY') + '.xlsx');
  }
  pagination(data) {
    this.addObj['page'] = data['page'],
      this.addObj['limit'] = data['limit'];
    this.submitForm(this.addObj)
  }

  processPagination(data, req) {
    this.showTable = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.count, req.limit),
    }
    this.showTable = true;
  }
  getTotalCount(total, limit) {
    let result: any = 1;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

}
